// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__3tjiY","title":"AfterBackImages_title__rCnnv","images":"AfterBackImages_images__3ONn7"};